import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.SUPABASE_URL ? process.env.SUPABASE_URL : process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.SUPABASE_KEY ? process.env.SUPABASE_KEY : process.env.REACT_APP_SUPABASE_KEY
export const supabase = createClient(supabaseUrl, supabaseKey)
